// @greenlight-spec: 19-design-system.md
import { MoreHorizontal } from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils';
import type { BottomNavSlot } from '@/lib/nav';

interface MobileBottomNavProps {
  slots: readonly BottomNavSlot[];
  onMore: () => void;
}

export function MobileBottomNav({ slots, onMore }: MobileBottomNavProps) {
  return (
    <nav
      aria-label="Mobile primary"
      data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 h-14 border-t border-border bg-card flex items-stretch z-30 pb-[env(safe-area-inset-bottom)]"
    >
      {slots.map((slot) => {
        const Icon = slot.icon;
        return (
          <NavLink
            key={`${slot.to}-${slot.label}`}
            to={slot.to}
            className={({ isActive }) =>
              cn(
                'flex-1 flex flex-col items-center justify-center gap-0.5 text-[11px] min-h-11',
                isActive ? 'text-foreground border-t-2 border-primary' : 'text-foreground',
              )
            }
          >
            <Icon className="size-5" aria-hidden />
            <span>{slot.label}</span>
          </NavLink>
        );
      })}
      <button
        type="button"
        onClick={onMore}
        aria-label="Open navigation menu"
        data-testid="bottom-nav-more"
        className="flex-1 flex flex-col items-center justify-center gap-0.5 text-[11px] min-h-11 text-foreground"
      >
        <MoreHorizontal className="size-5" aria-hidden />
        <span>More</span>
      </button>
    </nav>
  );
}
